// extracted by mini-css-extract-plugin
export default {"section":"GrowthChartSection_section__Oho6H","card":"GrowthChartSection_card__vqtsi","visible":"GrowthChartSection_visible__2PqUP","title":"GrowthChartSection_title__sg5Bb"};